import { USER_ACTIONS } from '../Actions/userActions';
import { log } from "../../Helpers/logger";

// État initial
const INITIAL_STATE = {
  id: null,
  email: null,
  nickname: null,
  character: null,
  gameData: null,
  hasCharacter: false,
  isAuthenticated: false,
  loading: false,
  error: null
};

// Reducer utilisateur
export const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Définir l'utilisateur (connexion)
    case USER_ACTIONS.SET: {
      log.reducer.log('USER_ACTIONS.SET payload:', action.payload);
      return {
        ...state,
        id: action.payload.id,
        email: action.payload.email,
        nickname: action.payload.nickname,
        gameData: action.payload.gameData || null,
        hasCharacter: action.payload.hasCharacter || false,
        isAuthenticated: true,
        loading: false,
        error: null
      };
    }
    
    // Effacer l'utilisateur (déconnexion)
    case USER_ACTIONS.CLEAR: {
      return {
        ...INITIAL_STATE,
        isAuthenticated: false
      };
    }
    
    // Mettre à jour le personnage
    case USER_ACTIONS.UPDATE_CHARACTER: {
      log.reducer.log('UPDATE_USER_CHARACTER action:', action);
      return {
        ...state,
        ...action.payload,
        hasCharacter: true,
        updatedAt: new Date().toISOString()
      };
    }
    
    // Mettre à jour le statut d'authentification
    case USER_ACTIONS.SET_AUTH_STATUS: {
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated
      };
    }
    
    default:
      return state;
  }
};

// Sélecteurs
export const selectUser = (state) => state.user;
export const selectIsAuthenticated = (state) => state.user.isAuthenticated;
export const selectUserCharacter = (state) => state.user.character;